import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CloseXIcon from 'assets/closeXOneMore.svg?react';
// import { SearchIcon } from 'assets/search';
import SearchIcon from 'assets/search.svg?react';

interface Props {
  setSearch: (value: string) => void;
  setSearchOpen: (value: boolean) => void;
  searchOpen: boolean;
}

export const SearchBarMobile = ({ setSearch, searchOpen, setSearchOpen }: Props) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
  };

  const clearInput = () => {
    setInputValue('');
    setSearch('');
  };

  return (
    <div className="ml-7 flex justify-end">
      {searchOpen && (
        <div className="absolute top-0 flex h-[2.375rem] w-full min-w-[21rem] max-w-[23.5rem] items-center rounded-full border border-[#FFFFFF40] bg-indigo p-2">
          <input
            className="h-[2.375rem] w-full overflow-hidden text-ellipsis rounded-full bg-transparent p-2 text-sm text-violet-text placeholder-white/40 outline-none"
            placeholder={t('pages.liveGamesSection.search')}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            style={{
              direction: !isFocused && inputValue ? 'rtl' : 'ltr',
              textAlign: 'left',
            }}
          />
          {inputValue && (
            <button
              type="button"
              className="absolute right-2 flex h-[2.625rem] items-center"
              onClick={clearInput}
            >
              <CloseXIcon />
            </button>
          )}
          {!inputValue && (
            <button
              type="button"
              className="absolute right-2 flex items-center"
              data-testid="opened-search-icon"
              onClick={() => {
                setInputValue('');
                setSearchOpen(false);
              }}
            >
              <SearchIcon className="h-4 text-white" />
            </button>
          )}
        </div>
      )}

      <button
        className="flex h-[2.375rem] w-[2.375rem] items-center justify-center rounded-full border border-[#FFFFFF40] bg-indigo p-2"
        onClick={() => setSearchOpen(true)}
      >
        <SearchIcon className={'h-4 text-white'} />
      </button>
    </div>
  );
};
